<template>
    <tr>
        <td>{{ car.lot_date }}</td>
        <td>{{ car.auction_name}}</td>
        <td>{{ car.bid }}</td>
        <td>{{ car.company }}</td>
        <td>{{ car.model_name_en }}</td>
        <td>{{ car.model_type_en }}</td>
        <td>{{ car.model_year_en }}</td>
        <td>
            <button v-if="isLoading" class="button is-small date-select is-loading"></button>
            <jibaiseki-column v-else :car="car"></jibaiseki-column>
        </td>
        <td>{{ car.expected_exportation }}</td>
        <td>{{ jibaisekiStatus }}</td>
        <td>
            <button v-if="isLoading" class="button is-small date-select is-loading"></button>
            <jibaiseki-applied-column v-else :car="car"></jibaiseki-applied-column>
        </td>
        <td>
            <button v-if="isLoading" class="button is-small date-select is-loading"></button>
            <jibaiseki-refunded-column v-else :car="car"></jibaiseki-refunded-column>
        </td>
        <td>
            <button v-if="isLoading" class="button is-small date-select is-loading"></button>
            <jibaiseki-scan-column v-else :car="car"></jibaiseki-scan-column>
        </td>
    </tr>
</template>

<script>
    import JibaisekiColumn from './JibaisekiColumn'
    import JibaisekiAppliedColumn from './JibaisekiAppliedColumn'
    import JibaisekiRefundedColumn from './JibaisekiRefundedColumn'
    import JibaisekiScanColumn from './JibaisekiScanColumn'
    export default {
        props: ['car'],
        components: {
            JibaisekiColumn,
            JibaisekiAppliedColumn,
            JibaisekiRefundedColumn,
            JibaisekiScanColumn
        },
        computed: {
            jibaisekiStatus() {
                if (this.car.jibaiseki_refunded) {
                    return 'Refunded'
                } else if (this.car.jibaiseki_applied) {
                    return 'Applied'
                } else  {
                    return 'Not applied'
                }
            },
            isLoading() {
                return this.$store.getters.getLoaderStatus
            }
        }
    }
</script>

<style scoped>
    td {
        font-size: 10px;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Jibaiseki/JibaisekiTableRow.vue